import { Component } from '@angular/core';
import { ErrorService } from 'src/app/core/error.service';
import { SellerSummary, SellersService } from 'src/app/core/sellers.service';

@Component({
  selector: 'app-sellers-summary',
  templateUrl: './sellers-summary.component.html',
  styleUrls: ['./sellers-summary.component.scss'],
})
export class SellersSummaryComponent {
  is_summary_request_running: boolean = true;
  summary?: SellerSummary;

  constructor(private error_service: ErrorService, private sellers_service: SellersService) {}

  ngOnInit(): void {
    this.readSummary();
  }

  onRefresh(): void {
    this.readSummary();
  }

  readSummary(): void {
    this.is_summary_request_running = true;
    this.sellers_service.readSummary().subscribe({
      next: response => {
        this.summary = response.data;
        this.is_summary_request_running = false;
      },
      error: error => {
        this.error_service.processGenericApiError(error);
        this.is_summary_request_running = false;
      },
    });
  }
}
